<template>
  <div>
    <div class="text-right mb-3">
      <button class="btn btn-primary" :disabled="carregando || salvando || !apiKey" @click="editar()">
        <i class="fa fa-plus"></i> Nova resposta
      </button>
    </div>
    <div class="card shadow-sm mb-4 mb-md-0">
      <div class="card-body">
        <loading v-if="carregando"/>
        <div v-else-if="erro" class="alert alert-danger">
          {{ erro }}
          <button class="btn btn-link p-0 ml-2" @click="carregar">Tentar novamente</button>
        </div>
        <div v-else class="table-responsive">
          <table class="table mb-0">
            <thead>
              <tr>
                <th>Respostas</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in respostas" :key="item.chave || item.id_resposta">
                <td class="align-middle pointer" @click="editar(item)">
                  {{ item.nome || item.contexto }}
                  <div v-if="item.nome" class="small">{{ item.contexto }}</div>
                </td>
                <td class="text-right align-middle text-nowrap">
                  <button type="button" role="switch" :aria-checked="ativo(item)"
                          :aria-label="item.nome || item.contexto"
                          class="btn btn-link p-0 mr-2 text-dark text-decoration-none"
                          :disabled="salvando" @click="alternar(item)">
                    <span class="small mr-2">{{ ativo(item) ? 'Ativada' : 'Desativada' }}</span>
                    <img v-if="ativo(item)" class="switch" src="../../assets/icons/switch-on.svg" alt=""/>
                    <img v-else class="switch" src="../../assets/icons/switch-off.svg" alt=""/>
                  </button>
                  <button v-if="item.id_resposta && !item.chave" class="btn btn-action btn-dark btn-sm mr-1"
                          aria-label="Excluir resposta" :disabled="salvando" @click="excluir(item)">
                    <i class="fa fa-trash-alt"></i>
                  </button>
                  <button class="btn btn-action btn-info btn-sm" aria-label="Editar resposta"
                          :disabled="salvando" @click="editar(item)">
                    <i class="fa fa-pen"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <modal :opened="!!formulario" @fechar="fechar">
          <div v-if="formulario">
            <h2 class="font-weight-bold">{{ formulario.nome || (formulario.id_resposta ? 'Editar resposta' : 'Nova resposta') }}</h2>
            <div class="alert alert-info small">
              <i class="fa fa-info-circle mr-1"></i>
              {{ formulario.chave === 'quebra_gelo'
                ? 'Oriente o cliente sobre o que ele pode perguntar na abertura do atendimento.'
                : 'Descreva em quais situações o bot deve enviar esta resposta.' }}
            </div>
            <div v-if="formulario.padrao" class="form-group mb-2">
              <label class="mb-1">
                <input v-model="formulario.personalizada" type="checkbox" class="mr-1">
                Personalizar resposta
              </label>
            </div>
            <div v-if="formulario.chave !== 'quebra_gelo'" class="form-group">
              <label for="resposta-contexto">Quando o bot deve responder?</label>
              <textarea id="resposta-contexto" :value="conteudoFormulario('contexto')" :disabled="formulario.padrao && !formulario.personalizada"
                        @input="formulario.contexto = $event.target.value" class="form-control" rows="4"
                        maxlength="512" style="resize: none" placeholder="Ex.: O cliente pergunta se vocês fazem entrega."/>
            </div>
            <div class="form-group">
              <label for="resposta-texto">{{ formulario.chave === 'quebra_gelo' ? 'Mensagem de abertura' : 'Resposta' }}</label>
              <textarea id="resposta-texto" :value="conteudoFormulario('resposta')" :disabled="formulario.padrao && !formulario.personalizada"
                        @input="formulario.resposta = $event.target.value" class="form-control" rows="7" maxlength="512" style="resize: none"/>
            </div>
            <div v-if="formulario.chave !== 'quebra_gelo'" class="form-group">
              <label class="mb-1">
                <input type="checkbox" class="mr-1"
                       :checked="formulario.padrao && !formulario.personalizada
                         ? Number(formulario.padrao.adaptar_resposta) === 1
                         : formulario.adaptar_resposta"
                       :disabled="formulario.padrao && !formulario.personalizada"
                       @change="formulario.adaptar_resposta = $event.target.checked">
                Adaptar resposta com IA
              </label>
              <small class="d-block text-muted">Ajusta o texto à pergunta usando as informações da resposta cadastrada.</small>
            </div>
          </div>
          <template #acoes>
            <button v-if="formulario" class="btn btn-success px-4 py-2" :disabled="salvando || (formulario.padrao && !formulario.id_resposta && !formulario.personalizada)" @click="salvar">
              Salvar
            </button>
          </template>
        </modal>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/commons/Loading";
import Modal from "@/components/commons/Modal";

const endpoint = 'v2/chatbot/respostas';

export default {
  name: 'Respostas',
  components: { Loading, Modal },
  props: { apiKey: { type: String, required: true } },
  data() {
    return {
      respostas: [],
      formulario: null,
      carregando: false,
      salvando: false,
      erro: '',
      versaoConsulta: 0,
    };
  },
  computed: {
    configHttp() {
      return { emulateJSON: false, headers: { 'x-lecard-key': this.apiKey } };
    },
  },
  watch: {
    apiKey: { immediate: true, handler: 'carregar' },
  },
  methods: {
    ativo(item) {
      return Number(item.fg_ativo) === 1;
    },
    mensagemErro(erro, mensagem) {
      return (erro.data && erro.data.msg) || mensagem;
    },
    async carregar() {
      const consulta = ++this.versaoConsulta;
      this.carregando = !!this.apiKey;
      this.erro = '';

      if (!this.apiKey) {
        this.respostas = [];
        this.erro = 'Não foi possível autenticar a empresa.';
        return;
      }

      try {
        const res = await this.$http.get(endpoint, this.configHttp);
        if (consulta === this.versaoConsulta) this.respostas = res.data;
      } catch (erro) {
        if (consulta === this.versaoConsulta) this.erro = this.mensagemErro(erro, 'Não foi possível carregar as respostas.');
      } finally {
        if (consulta === this.versaoConsulta) this.carregando = false;
      }
    },
    editar(item) {
      if (this.salvando) return;
      this.formulario = item
        ? { ...item, adaptar_resposta: Number(item.adaptar_resposta) === 1 }
        : { contexto: '', resposta: '', adaptar_resposta: false };
    },
    fechar() {
      if (!this.salvando) this.formulario = null;
    },
    async gravar(url, dados) {
      if (this.salvando) return;
      this.salvando = true;

      try {
        await this.$http.post(url, dados, this.configHttp);
        this.formulario = null;
        await this.carregar();
      } catch (erro) {
        this.$swal(this.mensagemErro(erro, 'Não foi possível atualizar a resposta.'));
      } finally {
        this.salvando = false;
      }
    },
    conteudoFormulario(campo) {
      const { padrao, personalizada } = this.formulario;
      return padrao && !personalizada ? padrao[campo] : this.formulario[campo];
    },
    salvar() {
      const { id_resposta, chave, contexto, resposta, personalizada, padrao } = this.formulario;
      const usarPadrao = padrao && !personalizada;

      if (!usarPadrao && (!contexto.trim() || !resposta.trim())) {
        this.$swal('Preencha os campos para salvar a resposta.');
        return;
      }

      const dados = {
        contexto: usarPadrao ? null : contexto,
        resposta: usarPadrao ? null : resposta,
      };
      if (!usarPadrao) dados.adaptar_resposta = this.formulario.adaptar_resposta ? 1 : 0;
      if (id_resposta) {
        dados.id_resposta = id_resposta;
      } else if (chave) {
        dados.chave = chave;
      }
      this.gravar(endpoint, dados);
    },
    async alternar(item) {
      if (this.salvando) return;

      const statusAnterior = item.fg_ativo;
      const fg_ativo = this.ativo(item) ? 2 : 1;
      const dados = item.id_resposta
        ? { id_resposta: item.id_resposta, fg_ativo }
        : { chave: item.chave, fg_ativo };

      this.salvando = true;
      item.fg_ativo = fg_ativo;

      try {
        const { data } = await this.$http.post(endpoint, dados, this.configHttp);
        if (!item.id_resposta) item.id_resposta = data.id_resposta;
      } catch (erro) {
        item.fg_ativo = statusAnterior;
        this.$swal(this.mensagemErro(erro, 'Não foi possível atualizar a resposta.'));
      } finally {
        this.salvando = false;
      }
    },
    async excluir(item) {
      const confirmar = await this.$swal({
        text: 'Deseja excluir esta resposta?',
        buttons: ['Cancelar', 'Excluir'],
        dangerMode: true,
      });

      if (confirmar) this.gravar(`${endpoint}/${item.id_resposta}/excluir`, {});
    },
  },
};
</script>
